import {render} from 'preact';
import $ from '@modules/jquery-import';
import isSiteFeatureEnabled from '@util/fn/isSiteFeatureEnabled';
import mediaQuery from '@util/media-queries';
import namespace from '../../upi/namespace';
import {Corpus, jqueryContentToggle, jquerySmartResize} from '@modules/lazy-imports';
import UpiContextProvider from '@providers/UpiContextProvider';
import {AccordionItem} from '@ultradent/components';
import CustomerReviews from '@containers/CustomerReviews';
import PageNavigation from '@components/common/PageNavigation';
import PastPurchasesQuery from '@containers/PastPurchases';

import PurchasedLineItem from '@components/pastPurchases/LineItem';
import ImageZoom from '@modules/ui/ImageZoom';
import PhotoGallery from '@modules/ui/PhotoGallery';
import Swiper from 'swiper/bundle';

function makeToggleable ( {selector, showCount} ) {
    const $list = $( selector );

    if ( $list.length > showCount ) {
        const contentSet = $list.eq( showCount - 1 ).nextAll();
        contentSet.toContentToggle( {
            label: upi.i18n.getTextFromKey( 'lbl-viewMore', 'View more' )
        } );
    }
}

function preloadImage ( url, onsuccess, onerror ) {
    var img = new Image();
    img.src = url;
    img.onload = onsuccess;
    img.onerror = onerror;
}

var app = namespace( 'apps.productpage' ),

    PageController = Backbone.View.extend( {

        el: '#body-content',

        nodes: {
            '$upiDialog': '#upi-dialog',
            '$leaveAReview': '.js-leave-a-review',
            '$warrantyInfo': '#yearwarrantylinkwrapper',
            '$productFamilyOverview': '#productFamilyOverview',
            '$customerReviews': '#customer-reviews-container',
            '$contentSections': '.product-content-section',
            '$productInformationWrapper': '#productInformationWrapper',
            '$productImageWrapper': '#productImageWrapper',
            '$pastPurchasesRecommendations': '#pastPurchasesRecommendations'
        },

        initNodes () {
            var nodes = this.nodes;
            for ( var node in nodes ) {
                if ( nodes.hasOwnProperty( node ) ) {
                    nodes[node] = this.$el.find( nodes[node] );
                }
            }
        },

        initialize () {
            // page initialization
            this.currentBreakPoint = mediaQuery.getCurrentBreakPoint();

            PageNavigation.initialize( '#header--main' );

            this.app = namespace( 'apps.productpage' );

            this.mountDialog();
            this.initNodes();

            this.Model = window.upi.apps.productpage.ProductModel;

            this.handleMobileZoomImageInteraction = this.handleMobileZoomImageInteraction.bind( this );

            this.initCustomerReviews();
            this.initCarousels( this.nodes.$contentSections );
            this.initPastPurchases();
            this.initWarrantyDetail();
            this.initLeaveAReview();
            this.initDesktopImageZoom( this.nodes.$productImageWrapper );
            this.initMobileImageZoom( this.nodes.$upiDialog );

            this.nodes.$productImageWrapper.on( 'click', '[data-image-zoom]', this.handleMobileZoomImageInteraction );

            if ( window.matchMedia( mediaQuery.max['screenMedium'] ).matches ) {
                this.applyContentToggles();
                this.applyMediaEmbeds();
            }

        },

        async initCarousels ( scope ) {
            await Corpus();
            this.configureCarousels( scope );

            await jquerySmartResize();
            $( window ).smartresize( () => {
                var bp = mediaQuery.getCurrentBreakPoint();
                if ( bp !== this.currentBreakPoint ) {
                    scope.corpus( 'off' );
                    this.configureCarousels( scope );
                    this.currentBreakPoint = bp;
                }
            } );

            const restorationSolutionCarousel = scope.find( '.restorative-solution-carousel' );
            console.log( '[PageController] - restorationSolutionCarousel',
                restorationSolutionCarousel,
                restorationSolutionCarousel[0] );
            if ( restorationSolutionCarousel[0] !== undefined ) {
                let selectedIndex = 0;
                const selectedSlide = restorationSolutionCarousel.data( 'restorative-solution-active' );
                const slides = restorationSolutionCarousel.find( '.swiper-slide' );
                slides.each( ( index, slide ) => {
                    if ( slide.dataset.restorativeSolution === selectedSlide ) {
                        selectedIndex = index;
                    }
                } );

                new Swiper( '.restorative-solution-carousel', {
                    initialSlide: selectedIndex,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                    loop: false,
                    watchOverflow: true,
                    breakpoints: {
                        752: {
                            slidesPerView: 3
                        },
                        1280: {
                            slidesPerView: 6
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                } );
            }

        },

        initDesktopImageZoom ( scope ) {
            const insertionNode = document.createElement( 'div' );
            insertionNode.classList.add( 'pointer-events-none', 'absolute', 'w-full', 'h-full' );
            this.nodes.$productInformationWrapper.prepend( insertionNode );

            const zoomOptions = {previewInsertionNode: insertionNode};
            const zoom = ImageZoom( scope[0], zoomOptions );
            zoom.init();
        },

        initMobileImageZoom ( scope ) {
            // note - initialize with empty collection - to be set by current preview context
            this.gallery = new PhotoGallery( scope, {
                previewer_controls: true,
                control_placement: 'bottom',
                collection: [],
                slide_controller: {
                    attributes: ['image', 'title', 'description'],
                    thumbnail_size: 48,
                    slide_increment: 8
                }
            } );
        },

        handleMobileZoomImageInteraction ( e ) {
            if ( window.matchMedia( mediaQuery.min['screenMedium'] ).matches ) {
                console.log( '[PageController] - Ignore image zoom interaction for non-mobile devices' );
                return;
            }

            const url = new URL( e.currentTarget.src );
            this.openMobileImageGallery( url.pathname );
        },

        getValidImageCollectionForZoom () {
            // build image collection from current collection im productImageController
            let imageList = this.app.productImageModuleView.collection.map( model => ({
                isVideo: model.get( 'videoId' ),
                image: {
                    source: model.get( 'src' )
                }
            }) );

            // exclude video previews from image gallery
            imageList = imageList.filter( ( {isVideo} ) => !isVideo );

            // preload images removing any that fail to load
            let imagesLoaded = imageList.map( ( node, index ) => {
                return new Promise( ( resolve, reject ) => {
                    preloadImage(
                        node.image.source,
                        () => resolve( node ),
                        () => {
                            imageList = imageList.slice( 0, index )
                                .concat( imageList.slice( index + 1, imageList.length ) );

                            reject( null );
                        }
                    );
                } )
            } );

            return Promise.all( imagesLoaded ).finally( () => imageList );
        },

        async openMobileImageGallery ( targetSrc ) {
            const imageList = await this.getValidImageCollectionForZoom( targetSrc );

            // note -> should not init if collection is 0
            if ( imageList.length > 0 ) {
                this.gallery.collection.populate( imageList );
                // set preview selection based on clicked target.src
                const pattern = new RegExp( `.*${targetSrc}$`, 'i' );
                const collection = this.gallery.thumb_control.slide_collection.all();
                let selection = collection.find( ( {image} ) => pattern.test( image.source ) );
                if ( selection ) {
                    this.gallery.thumb_control.change_slide( selection.id );
                }

                this.gallery.ready( () => {
                    this.nodes.$upiDialog.show();
                    this.toggleDocumentScrolling( false );
                } );
            }

        },

        toggleDocumentScrolling ( enabled ) {
            $( 'html' ).toggleClass( 'is-locked', !enabled );
        },

        mountDialog () {
            var $dialog = $( `
                <div id="upi-dialog">
                    <span class="upi-dialog--close close cursor-pointer w-12 leading-none text-2xl font-thin">
                        &times;
                    </span>
                    <div class="upi-photo-gallery">
                        <div class="upi-photo-preview-zoom">
                            <div class="upi-photo-preview"></div>
                        </div>
                    </div>
                </div>
            ` );
            $dialog.prependTo( '#body-content' ).hide();
            $( '.upi-dialog--close' ).on( 'click', () => {
                $dialog.hide();
                this.toggleDocumentScrolling( true );
            } );

        },

        configureCarousels ( scope ) {
            // const mq = window.matchMedia;
            const opts = {multiplier: 2};

            if ( window.matchMedia( mediaQuery.min.screenBase ).matches || !window.matchMedia( 'only all' ).matches ) {
                opts.multiplier = 4;
            }
            else if ( window.matchMedia( mediaQuery.min.screenMedium ).matches ) {
                opts.multiplier = 3;
            }
            else if ( window.matchMedia( mediaQuery.min.screenSmall ).matches ) {
                opts.multiplier = 2;
            }
            else {
                opts.multiplier = 1;
            }

            scope.corpus( 'carousel', opts );
        },

        applyMediaEmbeds () {
            // set embed target for video containers
            this.nodes.$productFamilyOverview.find( '.videos a[href*="http://www.youtube.com"]' ).each( function () {
                this.setAttribute( 'data-embed-target', 'img-ratio-16x9' );
            } );
        },

        async applyContentToggles () {
            await jqueryContentToggle();

            $( '#footnotes' ).toContentToggle( {
                label: upi.i18n.getTextFromKey( 'lbl-seeFootnotes', 'See Footnotes' )
            } );

            makeToggleable( {
                selector: '#productFeatures [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productTechnicalDetails [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productSpecs [data-list-item]',
                showCount: 5
            } );
            makeToggleable( {
                selector: '#productClinicals [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productVideos [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productFAQs [data-list-item]',
                showCount: 3
            } );

            $( '#productProcedures [data-list="procedure"]' ).each( function () {
                makeToggleable( {
                    selector: $( this ).find( '[data-list-item]' ),
                    showCount: 1
                } );
            } );

            makeToggleable( {
                selector: '#productTestimonials [data-list="testimonial-videos"] article',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productTestimonials [data-list="testimonial-comments"] article',
                showCount: 2
            } );
        },

        initWarrantyDetail () {
            const warrantyInfo = this.nodes.$warrantyInfo[0];

            if ( warrantyInfo ) {
                let warrantySkus = warrantyInfo.dataset.warrantySkus;
                warrantySkus = String( warrantySkus ).split( ',' );
                warrantyInfo.classList.add( 'hidden' );

                this.app.mediator.bind( 'unset:sku', () => {
                    warrantyInfo.classList.add( 'hidden' );
                } );
                this.app.mediator.bind( 'set:sku', ( sku ) => {
                    if ( !sku ) {
                        return;
                    }
                    const excludesWarranty = warrantySkus.indexOf( sku.id ) === -1;
                    warrantyInfo.classList.toggle( 'hidden', excludesWarranty );
                } );
            }
        },

        initLeaveAReview () {
            const leaveAReview = this.nodes.$leaveAReview[0];

            // update {selected} sku param on "leave a review" link
            if ( leaveAReview ) {
                const originalUrl = new URL( leaveAReview.href, window.location.origin );
                this.app.mediator.bind( 'unset:sku', () => {
                    leaveAReview.setAttribute( 'href', originalUrl.toString() );
                } );
                this.app.mediator.bind( 'set:sku', ( sku ) => {
                    if ( !sku ) {
                        return;
                    }
                    const newUrl = new URL( originalUrl.toString() );
                    newUrl.searchParams.append( 'sku', sku.id );
                    leaveAReview.setAttribute( 'href', newUrl.toString() );
                } );
            }
        },

        initPastPurchases () {
            if ( !this.nodes.$pastPurchasesRecommendations[0] ) {
                return;
            }

            return render(
                <UpiContextProvider>
                    <PastPurchasesQuery brandId={this.Model.id}>
                        {( {loading, skuList} ) => {
                            if ( loading ) {
                                return <div>Loading...</div>
                            }

                            console.log( 'skuList', skuList )

                            return skuList.length > 0 ?
                                <AccordionItem
                                    isActive={true}
                                    className="clear"
                                    inactiveClassName="border-b border-grey-lightest border-solid"
                                    label={`${this.Model.name} Order History`}>
                                    {skuList.map( ( product, index ) =>
                                        <PurchasedLineItem
                                            product={product}
                                            dataLayer={{
                                                'data-promo-id': 'none',
                                                'data-promo-name': 'Product Page Recent Purchase',
                                                'data-promo-creative-name': product.kitName,
                                                'data-promo-position': `Product Page Recent Purchase ${index + 1}`
                                            }}/> )}
                                </AccordionItem>
                                : null
                        }}
                    </PastPurchasesQuery>
                </UpiContextProvider>,
                this.nodes.$pastPurchasesRecommendations[0] );

            console.warn( 'Brand order history not enabled for site context' );
        },

        initCustomerReviews () {
            if ( !this.nodes.$customerReviews[0] ) {
                return;
            }
            // Customer Reviews
            if ( isSiteFeatureEnabled( 'Reviews' ) ) {
                return render(
                    <UpiContextProvider>
                        <CustomerReviews/>
                    </UpiContextProvider>,
                    this.nodes.$customerReviews[0] );
            }

            console.warn( 'Customer Reviews not enabled for site context' );
        }

    } );

export default PageController;
